module.exports = __webpack_public_path__ + "img/logo-iress1.c5d7c07e.jpg";